import request from './request';
import {
  LoginInfo,
  ModifyInfo,
  modifyAddressStuta,
  selectTime,
} from '../interface/interface';
// 登陆
async function requestLogin(params: LoginInfo) {
  return await request.post('/api/v1/admin/login', params);
}
// 获取device列表
async function requestDeviceList() {
  return await request.get('/api/v1/admin/device');
}
// 获取某个device
async function requestDeviceInfo(id: number) {
  return await request.get(`/api/v1/admin/device/info/${id}`);
}

async function requestUserList() {
  return await request.get('/api/v1/admin/user');
}

async function requestUserInfo(id:number) {
  return await request.get(`/api/v1/admin/user/info/${id}`);
}


async function requestGroupList() {
  return await request.get(`/api/v1/admin/group`);
}


async function requestConfigList() {
  return await request.get(`/api/v1/admin/config`);
}

async function requestPutConfig(parm:any) {
  return await request.put(`/api/v1/admin/config`,parm);
}

// 修改某个device的参数
async function requestPutDevice(id:number, parm:any) {
  return await request.put(`/api/v1/admin/device/info/${id}`,parm);
}






export {
  requestLogin,
  requestDeviceList,
  requestDeviceInfo,
  requestUserList,
  requestUserInfo,
  requestGroupList,
  requestConfigList,
  requestPutConfig,
  requestPutDevice
};
